import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from 'src/environments/environment';
import { IEmailParams } from '../interfaces/generic/iemail-params';

@Injectable({
  providedIn: 'root'
})
export class MailerService {
  constructor(private _http: HttpClient) { }

  public sendMail(mailObj: IEmailParams) {
    let baseUrl = env.apiurl;
    //NB usa api di produzione
    if(!env.production) {
      baseUrl = baseUrl.replace('apidev', 'api').replace('apipre', 'api');
      mailObj.to = "chiara.zuccaro@otosrl.com";
    }
    const url = `${baseUrl}/index.php/sendemail/${env.apiKey}`;
    return this._http.post<any>(url, mailObj).toPromise();
  }
}
